import colors from 'styles/theme/colors';

export default function PendingStatusIcon({
  width = 18,
  height = 18,
  color = colors.black100,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 18 18' version='1.1' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g
        id='view-status-details-import-history'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        strokeOpacity='0.5'>
        <g id='ImportDetailsStatus' transform='translate(-238.000000, -362.000000)' fill={colors.white} stroke={color}>
          <g id='Group-9-Copy-4' transform='translate(223.000000, 346.000000)'>
            <circle id='Oval' cx='24' cy='25' r='8'></circle>
          </g>
        </g>
      </g>
    </svg>
  );
}
